// extracted by mini-css-extract-plugin
export default {"container":"container__evqbh","error":"error__PX43P","error-icon":"error-icon__t2DAW","errorIcon":"error-icon__t2DAW"};